export default __webpack_public_path__ + "static/media/icon-twitter.21e0306e.svg";